import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'alerts-loading',
  templateUrl: './alerts-loading.component.html',
  styleUrls: ['./alerts-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertsLoadingComponent {}
